module.exports = __webpack_public_path__ + "static/media/cardinal_full.54d89dc8.svg";